module.exports = __webpack_public_path__ + "img/ctrl-pauli-x-dagger-stub-+.9835964b.svg";